import "./style.scss"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react";
import { goWhatsApp } from "../../utils/data/index.js";
const ChatCom = ({ url, text }) => {
    const [whatsUrl, setWhatsUrl] = useState();
    const [fbUrl, setFbUrl] = useState();
    const dispatch = useDispatch();
    const Setdata = useSelector(state => state.SetWeb.SetWebData);
    console.log("Setdata1", Setdata);
    useEffect(() => {

        if (url) {
            setWhatsUrl(url);
        } else {
            setWhatsUrl('https://wa.me/8617391995153?text=%E5%92%A8%E8%AF%A21V1%E8%AF%BE%E7%A8%8B');
        }
    }, [Setdata])
    const chatUs = (url) => {
        goWhatsApp();
        // window.open(url);
    };
    const getCookie = (name) => {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    return (
        <div className="chat">
            <p className="chat-text">{text ? text : '即刻搶免費試堂'}</p>
            {
                <img className="whatsIcon" src="../assets/whatsapp.png" alt="" onClick={() => { chatUs(whatsUrl) }} />
            }
            {
                fbUrl ? <img className="fbIcon" src="../assets/Facebook-Messenger-Logo.png" alt="" onClick={() => { chatUs(fbUrl) }} /> : ""
            }

        </div>
    )
}
export default ChatCom;